export default __webpack_public_path__ + "static/media/el6.d3a6a442.jpeg";